<script setup lang="ts">
const route = useRoute();
import { useArticleStore } from "@/stores/article";

if (!route.params.slug) {
  console.log("Warning! Make sure user is authenticated!");
}

const articleStore = useArticleStore();
await articleStore.fetch(route.params.slug);
const { item } = articleStore;

definePageMeta({
  layout: "default",
});

useHead({
  // script: [
  //   {
  //     src: "//mlb.valuecommerce.com/mylinkbox.js",
  //     type: "text/javascript",
  //     async: true,
  //   },
  // ],
});

useHead({
  title: item.title,
  meta: [
    { name: "description", content: item.description },
    { name: "og:title", content: item.title },
    { name: "og:description", content: item.description },
    { name: "twitter:title", content: item.title },
    { name: "thumbnail", content: item.top_image.url },
    { name: "og:image", content: item.top_image.url },
    { name: "twitter:image", content: item.top_image.url },
  ],
});
</script>

<template lang="pug">
v-container(class="pa-md-0").article
  v-row(align="center" justify="center")
    v-col(cols="12").text-center
      section.top-image
        img(:src="item.top_image.url")
  v-row(align="left" justify="left" class="my-0")
    v-col(cols="12").text-left
      span(class="published-at") {{item.published_at}}
  v-row(align="center" justify="center" class="my-0")
    v-col(cols="12" class="py-0").text-left
      section
        h1 {{ item.title }}
  v-row(align="left" justify="left")
    v-col(cols="12").text-left
      v-row.about-author(no-gutters align="center")
        v-col(cols=2 md=1)
          v-avatar(:image="item.author.image.icon.url" rounded=0)
        v-col(cols=10 md=11)
          strong.text-left {{item.author.name}}
  v-row(align="center" justify="center")
    v-col(cols="12").text-center
      p.summary {{ item.description }}
  v-row(align="center" justify="center")
    v-col(cols="12").text-center
      div.toc
        Toc(:items="item.headings")
      div.content(v-html="item.parsed_content")

CategoryList
</template>

<style lang="scss" scoped>
.article {
  width: 700px;
  margin-bottom: 50px;

  span.published-at {
    color: #707070;
  }
  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }

  p.summary,
  div.content {
    line-height: 2rem;
    text-align: left;
  }

  div.content {
    text-align: left;
    :deep(h2) {
      text-align: left;
      font-size: 1.6rem;
      margin: 30px auto 10px auto;
    }
    :deep(h3) {
      text-align: left;
      font-size: 1.4rem;
      margin: 30px auto 10px auto;
    }
    :deep(strong) {
      background: linear-gradient(transparent 57%, #fdf50d 0);
    }
    :deep(.a2a_kit) {
      text-align: center;
    }

    :deep(img):not([height="1"]) {
      width: 100%;
      height: 400px;
      object-fit: cover;
    }
    :deep(table) {
      border-collapse: collapse;
      tr {
        border-bottom: 1px solid #e7e7e7;
      }
      td {
        padding: 5px;
      }
    }
  }
}

.news {
  line-height: 2rem;
}

@media (max-width: 576px) {
  .v-container {
    width: 100%;
    img {
      height: 200px;
    }

    div.content {
      :deep(h3) {
        margin: 30px auto 10px auto;
      }
    }
  }
}
</style>
